export const backEndUrl = process.env.NODE_ENV === 'production'
  ? ''
  : 'http://127.0.0.1:8000';
